import { ExploreFilter } from "@/modules/explore/exploreTypes"
import { type BenchmarkDto } from "@modules/benchmark/api/benchmarkDto"
import { BenchmarkCategories, type BenchmarkCategory } from "@modules/benchmark/benchmarkTypes"
import { type Chrono } from "@modules/chrono/chronoTypes"
import { convertChronoFromDto } from "@modules/chrono/services/chronoDtos"

export class BenchmarkEntity {
  id: string
  title: string
  description: string
  _type: ExploreFilter.BENCHMARK
  category: BenchmarkCategory
  chrono: Chrono | null
  isFavorite: boolean
  rpe: number | null

  constructor(benchmark: BenchmarkEntity) {
    this.id = benchmark.id
    this.title = benchmark.title
    this.description = benchmark.description
    this._type = benchmark._type
    this.category = benchmark.category
    this.chrono = benchmark.chrono
    this.isFavorite = benchmark.isFavorite
    this.rpe = benchmark.rpe
  }

  static fromDto(dto: BenchmarkDto): BenchmarkEntity {
    return new BenchmarkEntity({
      ...dto,
      _type: ExploreFilter.BENCHMARK,
      category: BenchmarkCategories.includes(dto.category as BenchmarkCategory)
        ? (dto.category as BenchmarkCategory)
        : BenchmarkCategories[0],
      chrono: dto.chrono ? convertChronoFromDto(dto.chrono) : null,
    })
  }
}
